export default __webpack_public_path__ + "static/media/cleanproBirthdayBanner.29582b85.jpg";